import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { BootstrapAlert } from "../../components/BootstrapAlert";
import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import {
  useGetTrainingMenuBasedOnModuleQuery,
  useBookmarkModuleMutation,
  useUpdateModuleStatusMutation,
} from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const navigate = useNavigate();

  /* Start useState */

  const [skipGetTrainingMenu, setSkipGetTrainingMenu] = useState(false);

  /* End useState */

  const { isLoading: isMenuFetched } = useGetTrainingMenuBasedOnModuleQuery(4, {
    skip: skipGetTrainingMenu,
  });

  const [
    updateModuleStatus,
    {
      isLoading,
      status: updateStatus,
      error: { data: { message: errorMessage } = {} } = {},
    },
  ] = useUpdateModuleStatusMutation();

  const [bookmarkModule, { status: bookmarkStatus }] =
    useBookmarkModuleMutation();

  if (bookmarkStatus === "fulfilled") {
    navigate("/module-4/indications");
  }
  /* Start useEffect */

  useEffect(() => {
    if (updateStatus === "fulfilled") {
      bookmarkModule({ pathName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateStatus]); // * onUpdateMenu Status
  /* End useEffect */

  const handleStartModuleFour = () => {
    setSkipGetTrainingMenu(true);
    updateModuleStatus({ moduleNo: 4, start: 1 });
  };

  return (
    <div className="row">
      {isMenuFetched && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <div className="col-sm-8">
        <div className="module-content">
          <h1 className="blue text-uppercase b mt-5 mb-4">
            Additional Scans for Review (optional)
          </h1>
          <p className="d-inline me-4 b">1 Hour</p>
          <p className="d-inline me-4 b">English</p>
          <p className="d-inline me-4 b">MIM Referring Required</p>
          <h2 className="b text-uppercase mt-4">
            <span className="orange">Challenge</span> Yourself With More Real
            Case Studies
          </h2>
          <article className="mt-5">
            <h3 className="b mb-3">In this module</h3>
            <ul>
              <li>Indication and Limitations of Use</li>
              <li>Important Safety Information</li>
              <li>20 real case studies for assessment</li>
            </ul>
          </article>
          <article className="mt-5 mb-5">
            <h3 className="b mb-3">Key learning</h3>
            <ul>
              <li>This training resource will allow you access to additional practice cases for you to review and complete at your convenience</li>
              <li>
                Videos will be provided to take you through the read methodology
              </li>
            </ul>
          </article>

          <BootstrapAlert variant="danger" message={errorMessage} />
          <LdsButton
            className="blue-button mt-3 mb-5"
            disabled={isLoading}
            onClick={handleStartModuleFour}
          >
            Start Module Now
          </LdsButton>
        </div>
      </div>
    </div>
  );
};

export default Module_1_0;
